var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 16H16V496H496V16Z",
    fill: "#C0392B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M255.981 131C325.035 131 380.975 186.984 380.975 255.991C380.975 325.046 325.035 381 255.981 381C186.927 381 131.025 325.046 131.025 255.991C131.025 186.984 186.927 131 255.981 131",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M291.314 334.194C248.113 334.194 213.118 299.154 213.118 255.99C213.118 212.83 248.113 177.805 291.314 177.805C311.846 177.805 330.468 185.829 344.444 198.751C326.684 174.205 297.833 158.24 265.236 158.24C211.244 158.24 167.556 202 167.556 255.99C167.556 309.957 211.244 353.716 265.236 353.716C297.833 353.716 326.684 337.749 344.444 313.206C330.468 326.218 311.846 334.194 291.314 334.194",
    fill: "#C0392B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M287.088 203.092L309.59 234.487L346.443 222.762L323.536 253.885L346.038 285.253L309.388 273.083L286.482 304.214L286.724 265.58L250.074 253.41L286.893 241.701L287.081 203.092",
    fill: "#C0392B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTn);
export default __webpack_public_path__ + "static/media/TN.8eb4e402e88394a97c799a7486e9dca2.svg";
export { ForwardRef as ReactComponent };